import { render, staticRenderFns } from "./SupplierProductHome.vue?vue&type=template&id=3f28b451&scoped=true&"
import script from "./SupplierProductHome.vue?vue&type=script&lang=js&"
export * from "./SupplierProductHome.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProductHome.vue?vue&type=style&index=0&id=3f28b451&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28b451",
  null
  
)

export default component.exports